<template>
    <v-list nav dense class="admin-menu">
        <v-list-group
            v-for="section in adminMenuSections"
            :key="section.title"
            :prepend-icon="section.icon"
            :value="isSectionActive(section.items)"
            no-action
        >
            <template v-slot:activator>
                <v-list-item-content>
                    <v-list-item-title>{{ section.title }}</v-list-item-title>
                </v-list-item-content>
            </template>

            <v-list-item
                v-for="item in section.items"
                :key="item.to"
                link
                router
                :to="item.to"
                class="list"
              active-class="menu-item-active"
            >
                <v-list-item-action>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list-group>
    </v-list>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'admin',
  computed: {
    ...mapGetters(['getProfile']),
    adminMenuSections () {
      const profile = this.getProfile || {}
      const sections = [
        {
          title: 'Oficina',
          icon: 'mdi-office-building-outline',
          visible: profile.has_office === true,
          items: [
            { to: '/oficina/dashboard', icon: 'mdi-view-dashboard-outline', title: 'Dashboard' },
            { to: '/oficina/cuotas', icon: 'mdi-receipt-text-outline', title: 'Cuotas' },
            { to: '/oficina/usuarios', icon: 'mdi-account-tie-outline', title: 'Usuarios de Oficina' },
            { to: '/oficina/empleados', icon: 'mdi-badge-account-outline', title: 'Accesos de empleados' },
            { to: '/oficina/invitaciones', icon: 'mdi-send', title: 'Invitaciones de oficina' },
            { to: '/oficina/areas', icon: 'mdi-office-building-cog-outline', title: 'Áreas de oficina' },
            { to: '/oficina/reportes', icon: 'mdi-chart-box-outline', title: 'Reportes administrativos' }
          ]
        },
        {
          title: 'Mesa Directiva',
          visible: profile.has_directive_table === true,
          icon: 'mdi-scale-balance',
          items: [
            { to: '/mesa_directiva/inicio', icon: 'mdi-view-dashboard-outline', title: 'Inicio' },
            { to: '/mesa_directiva/integrantes', icon: 'mdi-account-group-outline', title: 'Integrantes' },
            { to: '/mesa_directiva/reuniones', icon: 'mdi-calendar-clock', title: 'Reuniones' },
            { to: '/mesa_directiva/votaciones', icon: 'mdi-ballot', title: this.$t('Encuestas') },
            { to: '/mesa_directiva/acuerdos', icon: 'mdi-clipboard-check-outline', title: 'Acuerdos' },
            { to: '/mesa_directiva/solicitudes', icon: 'mdi-inbox-outline', title: 'Solicitudes' }
          ]
        },
        {
          title: 'Accesos y visitas',
          icon: 'mdi-account-arrow-right-outline',
          items: [
            { to: '/current_invitations', icon: 'mdi-calendar-multiselect', title: this.$t('current_invitations') },
            { to: '/historical', icon: 'mdi-book-open-page-variant', title: this.$t('Historial') },
            {
              to: '/historical_no_code',
              icon: 'mdi-book-search',
              title: this.$t('Historial_avanzado'),
              visible: profile.idHousingUnit === '2c34ad01-90f3-4540-9263-33707827cbcf'
            },
            {
              to: '/guest_management',
              icon: 'mdi-account-remove',
              title: this.$t('guest_management'),
              visible: profile.can_remove_guests === true
            },
            { to: '/restricted_people', icon: 'mdi-account-off', title: this.$t('restricted_people') }
          ]
        },
        {
          title: 'Comunidad y reportes',
          icon: 'mdi-bullhorn-outline',
          items: [
            { to: '/notices', icon: 'mdi-bullhorn', title: this.$t('Notices') },
            { to: '/communication_channel', icon: 'mdi-email-open', title: this.$t('communication_channel') },
            { to: '/survey_admin', icon: 'mdi-ballot', title: this.$t('Encuestas') },
            { to: '/common_areas', icon: 'mdi-pool', title: this.$t('common_areas') },
            { to: '/reservation', icon: 'mdi-calendar-multiselect', title: this.$t('reservation') },
            {
              to: '/reports',
              icon: 'mdi-alert',
              title: this.$t('Reports'),
              visible: profile.enable_reports === true
            },
            { to: '/speeding_fines', icon: 'mdi-speedometer', title: 'Multas por Velocidad', visible: profile.has_speed_fines === true }
          ]
        },
        {
          title: 'Residentes y viviendas',
          icon: 'mdi-home-account',
          items: [
            { to: '/casas', icon: 'mdi-home-variant', title: this.$t('casas') },
            { to: '/directory', icon: 'mdi-bookmark-box-multiple', title: this.$t('directory') },
            { to: '/main_residents', icon: 'mdi-account-star', title: this.$t('residentes') },
            {
              to: '/pets',
              icon: 'mdi-dog-side',
              title: this.$t('pet_registrations') || 'Mascotas',
              visible: profile.vaccinationCampaignEnabled === true
            }
          ]
        },
        {
          title: 'Servicios y finanzas',
          icon: 'mdi-cash-multiple',
          items: [
            {
              to: '/parcel',
              icon: 'mdi-truck',
              title: this.$t('parcel'),
              visible: profile.enable_parcel === true
            },
            {
              to: '/water_service',
              icon: 'mdi-tanker-truck',
              title: this.$t('water_service'),
              visible: profile.water_service_enabled === true
            },
            { to: '/account_statements', icon: 'mdi-account-cash', title: this.$t('account_statements') }
          ]
        },
        {
          title: 'Personal y seguridad',
          icon: 'mdi-shield-account-outline',
          items: [
            { to: '/workers_admin', icon: 'mdi-badge-account', title: this.$t('workers') },
            {
              to: '/contractors_admin',
              icon: 'mdi-briefcase',
              title: this.$t('contractors'),
              visible: profile.contractors_enabled === true
            },
            { to: '/guards', icon: 'mdi-clipboard-account', title: this.$t('Vigilantes') },
            { to: '/guardhouses', icon: 'mdi-store-24-hour', title: this.$t('Casetas') }
          ]
        },
        {
          title: 'Casa Club',
          icon: 'mdi-golf',
          visible: profile.has_clubhouse === true,
          items: [
            { to: '/club_house_tournaments', icon: 'mdi-tournament', title: 'Torneos' },
            { to: '/club_house_socios', icon: 'mdi-account-multiple', title: 'Socios' }
          ]
        },
        {
          title: 'Configuracion y ayuda',
          icon: 'mdi-cog-outline',
          items: [
            { to: '/settings', icon: 'mdi-cog-outline', title: this.$t('configuracion') },
            { to: '/ayuda', icon: 'mdi-help-circle', title: this.$t('Ayuda') }
          ]
        }
      ]

      return sections
        .filter((section) => section.visible !== false)
        .map((section) => ({
          ...section,
          items: section.items.filter((item) => item.visible !== false)
        }))
        .filter((section) => section.items.length > 0)
    }
  },
  methods: {
    isSectionActive (items) {
      if (!this.$route || !this.$route.path) {
        return false
      }

      return items.some((item) => this.$route.path === item.to || this.$route.path.startsWith(`${item.to}/`))
    }
  }
}
</script>

<style scoped>
        .list:hover {
    background: rgba(255, 255, 255, 0.14);
    opacity: 1;
        }

        .admin-menu ::v-deep .v-list-group__header {
                min-height: 40px;
          border-left: 4px solid transparent;
          border-radius: 0 10px 10px 0;
          transition: background-color 0.2s ease, box-shadow 0.2s ease;
        }

        .admin-menu ::v-deep .v-list-group__header:hover {
          background: rgba(255, 255, 255, 0.12);
        }

        .admin-menu ::v-deep .v-list-group--active > .v-list-group__header {
          background: rgba(255, 255, 255, 0.2) !important;
          border-left-color: #43a047;
          box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.18);
        }

        .admin-menu ::v-deep .v-list-group--active > .v-list-group__header .v-list-item__title {
          color: #ffffff !important;
          font-weight: 700;
        }

        .admin-menu ::v-deep .v-list-group--active > .v-list-group__header .v-icon {
          color: #a5d6a7 !important;
        }

  .admin-menu ::v-deep .menu-item-active {
    background: rgba(255, 255, 255, 0.2) !important;
    border-left: 4px solid #43a047;
    border-radius: 0 10px 10px 0;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.18);
  }

  .admin-menu ::v-deep .menu-item-active .v-list-item__title {
    color: #ffffff !important;
    font-weight: 700;
  }

  .admin-menu ::v-deep .menu-item-active .v-icon {
    color: #a5d6a7 !important;
  }
</style>
